import { BCAHeaderWithAPI, BCAFooter } from "@bca/ui-library";
import getEnvironment from "./getEnvironment";

interface LayoutProps {
  user?: { firstName: string; lastName: string };
  children: React.ReactNode;
  idToken: string;
  isToUseAuthZero: boolean;
  isAuthenticated: boolean;
  logoutUrl?: string;
}

const Layout: React.FunctionComponent<LayoutProps> = ({
  user,
  children,
  idToken,
  isToUseAuthZero,
  isAuthenticated,
  logoutUrl,
}: LayoutProps) => {
  const environment = getEnvironment();
  const isProd = environment === "production";
  const isUat = environment === "preview";

  const magnoliaRootUrl = isProd
    ? "https://www.bca.co.uk/"
    : isUat
    ? "https://cms.uat.britishcarauctions.net/"
    : "https://cmsmain-dev.bca.co.uk/";

  const onHandleLogout = () => {
    if (isToUseAuthZero && isAuthenticated && logoutUrl) {
      window.location.href = logoutUrl;
    }
  };

  const shouldShowHeader = () => {
    if (!isToUseAuthZero) {
      return true;
    }

    if (isToUseAuthZero && isAuthenticated && user) {
      return true;
    }

    return false;
  };

  return (
    <>
      {shouldShowHeader() && (
        <BCAHeaderWithAPI
          key={user ? `${user.firstName}-${user.lastName}` : "no-user"}
          urls={{
            myBCAInfo: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/MyBCA-Menu`,
            navLinks: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Main-Menu`,
            searchRootURL: magnoliaRootUrl,
            // this is a required prop that is no longer needed/used
            login: "",
            logout: isToUseAuthZero
              ? null
              : isProd
              ? `https://login.bca.co.uk/connect/endsession?id_token_hint=${idToken}&post_logout_redirect_uri=https://www.bca.co.uk`
              : `https://login.uat.britishcarauctions.net/connect/endsession?id_token_hint=${idToken}&post_logout_redirect_uri=https://cms.uat.britishcarauctions.net`,
            vehicleOptions: isProd
              ? "https://auctionview.bca.co.uk/buyer/api/v1_0/FacetedSearchApi/VehicleTypes?cultureCode=en"
              : "https://auctionview.uat.britishcarauctions.net/buyer/api/v1_0/FacetedSearchApi/VehicleTypes?cultureCode=en",
            auctionViewRoot: isProd
              ? "https://auctionview.bca.co.uk/"
              : "https://auctionview.uat.britishcarauctions.net/",
            trackedLink: isProd
              ? "https://www.bca.co.uk/search?requestOrigin=Tracked"
              : "https://cms.uat.britishcarauctions.net/search?requestOrigin=Tracked",
          }}
          user={user ? user : undefined}
          onSignOutClick={onHandleLogout}
        />
      )}
      <main
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          zIndex: 0,
        }}
      >
        {children}
      </main>
      <BCAFooter
        urls={{
          navigationLinks: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Footer`,
          legalInfo: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Footer-Legal`,
          socialMedia: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Social-Links`,
        }}
      ></BCAFooter>
    </>
  );
};

export default Layout;
